/* istanbul ignore file */
export const getStyles = () => ({
  error: { color: '#a80000', marginTop: '8px' },
  languageCountryContainer: ({
    noShadow,
  }: { noShadow?: boolean }) => ({
    borderColor: 'transparent',
    boxShadow: noShadow ? 'none' :'0px 1.6px 3.6px rgba(0, 0, 0, 0.132), 0px 0.3px 0.9px rgba(0, 0, 0, 0.108)',
    padding: '20px',
    width: '100%',
    maxWidth: '400px',
  }),
  languageContainer: {
    marginBottom: '24px',
  },
  searchableDropdownSearchBox: {
    position: 'fixed',
    top: '0px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '100%',
    zIndex: '100',
  },
});
